<template>
  <div class="error-404">
    <div class="gbg404">
      <span class="oh404">Your cart is empty</span>
    </div>
    <div class="bbg404">
      <div class="btnhold404">
        <div style="">
          <a href="/best-selling-magazine-subscriptions" class="btn404" @click.prevent="handleClickBestSelling()">
            Shop Best Selling
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export default {
  name: 'CheckoutCartEmpty',
  serverCacheKey() {
    return 'CheckoutCartEmpty'
  },
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  layout: '1Column',
  methods: {
    handleClickBestSelling() {
      window.location.href = createPathOrURLWithQueryParam({ pathOrURL: '/best-selling-magazine-subscriptions', query: this.$route.query })
    }
  },
  // To check more options, link https://github.com/nuxt/vue-meta#script-object
  // To check how it is working https://nuxtjs.org/faq/duplicated-meta-tags/
  head() {
    return {
      title: 'Shopping Cart Empty',
      meta: [
        {
          name: 'keywords',
          content: 'Magazine.co.uk'
        },
        {
          name: 'robots',
          content: 'NOINDEX,NOFOLLOW'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.error-404 {
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 1230px;
  margin: 0px auto 20px auto;
}

.gbg404 {
  background-color: #ededed;
  text-align: center;
  padding: 50px;
  box-sizing: border-box;
}

.bbg404 {
  background-color: black;
  text-align: center;
  padding: 50px;
  box-sizing: border-box;
  color: white;
}

.oh404 {
  font-size: 50px;
  line-height: 70px;
}

.oh404--line2 {
  font-size: 30px;
  line-height: 70px;
}

.head404 {
  font-size: 50px;
  line-height: 50px;
  margin-bottom: 20px;
}

.subhead404 {
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 30px;
}

.btn404 {
  max-width: 350px;
  height: 72px;
  background-color: #e20d0c;
  color: white !important;
  text-decoration: none !important;
  font-size: 26px;
  font-weight: 600;
  line-height: 72px;
  display: block;
}

.btnhold404 {
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}

@media only screen and (max-width: 768px) {
  .gbg404 {
    padding: 40px;
  }

  .bbg404 {
    padding: 40px;
    min-height: 200px;
    line-height: 20vh;
  }

  .oh404 {
    font-size: 40px;
    line-height: 20vh;
  }

  .oh404--line2 {
    font-size: 30px;
    line-height: 50px;
  }

  .head404 {
    font-size: 40px;
    line-height: 40px;
  }

  .subhead404 {
    font-size: 24px;
    line-height: 24px;
  }

  .btn404 {
    max-width: 350px;
    height: 62px;
    line-height: 62px;
    font-size: 23px;
  }

  .btnhold404 {
    margin-top: 45px;
  }
}

@media only screen and (max-width: 767px) {
  .gbg404 {
    padding: 30px;
  }

  .bbg404 {
    padding: 30px;
  }

  .oh404 {
    font-size: 40px;
    line-height: 20vh;
  }

  .oh404--line2 {
    font-size: 30px;
    line-height: 50px;
  }

  .head404 {
    font-size: 26px;
    line-height: 26px;
  }

  .subhead404 {
    font-size: 16px;
    line-height: 16px;
  }

  .btn404 {
    max-width: 350px;
    height: 42px;
    line-height: 42px;
    font-size: 18px;
  }

  .btnhold404 {
    margin-top: 45px;
  }
}
</style>
